/* eslint-disable */
export default {
  currentCall: 'Aktueller Anruf',
  viewCalls: 'Anzeigen',
  view: 'Anzeigen',
  incomingCall: '{numberOf} eingeh. Anruf',
  incomingCalls: '{numberOf} eingeh. Anrufe',
  callOnHold: '{numberOf} Anruf wird gehalten',
  callsOnHold: '{numberOf} Anrufe werden gehalten',
  otherDeviceCall: '{numberOf} Anruf auf anderen Geräten',
  otherDeviceCalls: '{numberOf} Anrufe auf anderen Geräten',
} as const;

// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"viewCalls"@#@ @source: @#@"View Calls"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"incomingCall"@#@ @source: @#@"{numberOf} Incoming Call"@#@
// @key: @#@"incomingCalls"@#@ @source: @#@"{numberOf} Incoming Calls"@#@
// @key: @#@"callOnHold"@#@ @source: @#@"{numberOf} Call On Hold"@#@
// @key: @#@"callsOnHold"@#@ @source: @#@"{numberOf} Calls On Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"{numberOf} Call on other devices"@#@
// @key: @#@"otherDeviceCalls"@#@ @source: @#@"{numberOf} Calls on other devices"@#@
